import React, { Component } from 'react';
import { Container, Row, Col, Input, Button, Alert } from 'reactstrap';
import { Link } from 'react-router-dom';
import AuthFunctions from '../services/AuthService';
import Session from '../auth/Session';

export class AddLease extends Component {
    static displayName = AddLease.name;

    constructor(props) {
        super(props);
        this.state = {
            newLease: { sd_status : 1},
            sregionOptions: [{ label: "Branch", value: "Branch" }, { label: "Headquarters", value: "Headquarters" }, { label: "Independent", value: "Independent" }, { label: "Sublessor", value: "Sublessor" }],
            sstateOptions: [{ label: "AL", value: "AL" },
            { label: "AK", value: "AK" },
            { label: "AZ", value: "AZ" },
            { label: "AR", value: "AR" },
            { label: "CA", value: "CA" },
            { label: "CO", value: "CO" },
            { label: "CT", value: "CT" },
            { label: "DE", value: "DE" },
            { label: "DC", value: "DC" },
            { label: "FL", value: "FL" },
            { label: "GA", value: "GA" },
            { label: "HI", value: "HI" },
            { label: "ID", value: "ID" },
            { label: "IL", value: "IL" },
            { label: "IN", value: "IN" },
            { label: "IA", value: "IA" },
            { label: "KS", value: "KS" },
            { label: "KY", value: "KY" },
            { label: "LA", value: "LA" },
            { label: "ME", value: "ME" },
            { label: "MD", value: "MD" },
            { label: "MA", value: "MA" },
            { label: "MI", value: "MI" },
            { label: "MN", value: "MN" },
            { label: "MS", value: "MS" },
            { label: "MO", value: "MO" },
            { label: "MT", value: "MT" },
            { label: "NE", value: "NE" },
            { label: "NV", value: "NV" },
            { label: "NH", value: "NH" },
            { label: "NJ", value: "NJ" },
            { label: "NM", value: "NM" },
            { label: "NY", value: "NY" },
            { label: "NC", value: "NC" },
            { label: "ND", value: "ND" },
            { label: "OH", value: "OH" },
            { label: "OK", value: "OK" },
            { label: "OR", value: "OR" },
            { label: "PA", value: "PA" },
            { label: "RI", value: "RI" },
            { label: "SC", value: "SC" },
            { label: "SD", value: "SD" },
            { label: "TN", value: "TN" },
            { label: "TX", value: "TX" },
            { label: "UT", value: "UT" },
            { label: "VT", value: "VT" },
            { label: "VA", value: "VA" },
            { label: "WA", value: "WA" },
            { label: "WV", value: "WV" },
            { label: "WI", value: "WI" },
            { label: "WY", value: "WY" }
            ],
            sStatusOptions: [{ label: "Open", value: "1" }, { label: "Closed", value: "2" }],
            sleaseOptions: [{ label: "Full Service", value: "Full Service" }, { label: "Modified Gross", value: "Modified Gross" }, { label: "NNN", value: "NNN" }],
            sstatusOptions: [{ label: "Open", value: "Open" }, { label: "Closed", value: "Closed" }],
        }

        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    async componentDidMount() {
        var _token = Session.getToken();
    }

    render() {
        return (
            <div className="pageDiv">
                <div id="head">
                    <h3 style={{ textAlign: 'center' }}>Add</h3>
                </div>
                <div id="body" className="g-light-gray-c">
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Office/Store #
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input type="text"
                                    name="sd_num"
                                    value={this.state.newLease.sd_num}
                                    onChange={(e) => {
                                        var newLeaseTemp = this.state.newLease;
                                        newLeaseTemp.sd_num = e.target.value;
                                        this.setState({ newLease: newLeaseTemp });
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Type
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <select
                                    options={this.state.sregionOptions}
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    components={{
                                        Option
                                    }}
                                    onChange={(e) => {
                                        var newLeaseTemp = this.state.newLease;
                                        newLeaseTemp.sd_region = e.target.value;
                                        this.setState({ newLease: newLeaseTemp });
                                    }}
                                    value={this.state.newLease.sd_region}
                                    style={{ 'width': '163px' }}
                                >
                                    <option key=''></option>
                                    {this.state.sregionOptions.map(option => {
                                        return (
                                            <option key={option.value}>
                                                {option.label}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Building Name
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input type="text"
                                    name="sd_building"
                                    value={this.state.newLease.sd_building}
                                    onChange={(e) => {
                                        var newLeaseTemp = this.state.newLease;
                                        newLeaseTemp.sd_building = e.target.value;
                                        this.setState({ newLease: newLeaseTemp });
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Street Address
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input type="text"
                                    name="sd_address"
                                    value={this.state.newLease.sd_address}
                                    onChange={(e) => {
                                        var newLeaseTemp = this.state.newLease;
                                        newLeaseTemp.sd_address = e.target.value;
                                        this.setState({ newLease: newLeaseTemp });
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Street Address 2
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input type="text"
                                    name="sd_address2"
                                    value={this.state.newLease.sd_address2}
                                    onChange={(e) => {
                                        var newLeaseTemp = this.state.newLease;
                                        newLeaseTemp.sd_address2 = e.target.value;
                                        this.setState({ newLease: newLeaseTemp });
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            City
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input type="text"
                                    name="sd_city"
                                    value={this.state.newLease.sd_city}
                                    onChange={(e) => {
                                        var newLeaseTemp = this.state.newLease;
                                        newLeaseTemp.sd_city = e.target.value;
                                        this.setState({ newLease: newLeaseTemp });
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            State
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <select
                                    options={this.state.sstateOptions}
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    components={{
                                        Option
                                    }}
                                    onChange={(e) => {
                                        var newLeaseTemp = this.state.newLease;
                                        newLeaseTemp.sd_state = e.target.value;
                                        this.setState({ newLease: newLeaseTemp });
                                    }}
                                    value={this.state.newLease.sd_state}
                                    style={{ 'width': '163px' }}
                                >
                                    <option key=''></option>
                                    {this.state.sstateOptions.map(option => {
                                        return (
                                            <option key={option.value}>
                                                {option.label}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Zip
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input type="text"
                                    name="sd_zip"
                                    value={this.state.newLease.sd_zip}
                                    onChange={(e) => {
                                        var newLeaseTemp = this.state.newLease;
                                        newLeaseTemp.sd_zip = e.target.value;
                                        this.setState({ newLease: newLeaseTemp });
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Original Commencement Date
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input
                                    type="date"
                                    value={this.state.newLease.sd_ocd}
                                    onChange={(e) => {
                                        var newLeaseTemp = this.state.newLease;
                                        newLeaseTemp.sd_ocd = e.target.value;
                                        this.setState({ newLease: newLeaseTemp });
                                    }}
                                    name="sd_ocd"
                                    id='sd_ocd'
                                    style={{ 'width': '113px' }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Current Commencement Date
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input
                                    type="date"
                                    value={this.state.newLease.sd_ccd}
                                    onChange={(e) => {
                                        var newLeaseTemp = this.state.newLease;
                                        newLeaseTemp.sd_ccd = e.target.value;
                                        this.setState({ newLease: newLeaseTemp });
                                    }}
                                    name="sd_ccd"
                                    id='sd_ccd'
                                    style={{ 'width': '113px' }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Current Expiration Date
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input
                                    type="date"
                                    value={this.state.newLease.sd_ced}
                                    onChange={(e) => {
                                        var newLeaseTemp = this.state.newLease;
                                        newLeaseTemp.sd_ced = e.target.value;
                                        this.setState({ newLease: newLeaseTemp });
                                    }}
                                    name="sd_ced"
                                    id='sd_ced'
                                    style={{ 'width': '113px' }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Square Feet
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input type="text"
                                    name="sd_sqft"
                                    value={this.state.newLease.sd_sqft}
                                    onChange={(e) => {
                                        var newLeaseTemp = this.state.newLease;
                                        newLeaseTemp.sd_sqft = e.target.value;
                                        this.setState({ newLease: newLeaseTemp });
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Lease
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <select
                                    options={this.state.sleaseOptions}
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    components={{
                                        Option
                                    }}
                                    onChange={(e) => {
                                        var newLeaseTemp = this.state.newLease;
                                        newLeaseTemp.sd_lease = e.target.value;
                                        this.setState({ newLease: newLeaseTemp });
                                    }}
                                    value={this.state.newLease.sd_lease}
                                    style={{ 'width': '163px' }}
                                >
                                    <option key=''></option>
                                    {this.state.sleaseOptions.map(option => {
                                        return (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Security Deposit
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <input type="text"
                                    name="sd_deposit"
                                    value={this.state.newLease.sd_deposit}
                                    onChange={(e) => {
                                        var newLeaseTemp = this.state.newLease;
                                        newLeaseTemp.sd_deposit = e.target.value;
                                        this.setState({ newLease: newLeaseTemp });
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            Status
                        </Col>
                        <Col>
                            <div id="plain">&nbsp;
                                <select
                                    options={this.state.sStatusOptions}
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    components={{
                                        Option
                                    }}
                                    onChange={(e) => {
                                        var newLeaseTemp = this.state.newLease;
                                        newLeaseTemp.sd_status = e.target.value;
                                        this.setState({ newLease: newLeaseTemp });
                                    }}
                                    value={this.state.newLease.sd_status}
                                    style={{ 'width': '163px' }}
                                >
                                    <option key=''></option>
                                    {this.state.sStatusOptions.map(option => {
                                        return (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col style={{ textAlign: 'right' }} >
                            &nbsp;
                        </Col>
                        <Col>
                            <div id="controls" style={{ textAlign: 'left' }}>
                                <button className="gButton" style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "100px" }} onClick={() => {
                                    this.SaveLease();
                                }} >Add</button>
                            </div>
                        </Col>
                    </Row>
                </div>

            </div>
        );
    }

    //async SaveLease() {
    //    /*this.setState({ loading: true, loadingDocument: false });*/
    //    const token = Session.getToken();
    //    const response = await fetch('api/Leases/EditLease', {
    //        method: 'POST',
    //        headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
    //        body: JSON.stringify(this.state.newLease)
    //    }).then(function (myResponse) {
    //        var data = myResponse.json();
    //        if (data && data.sd_id) {
    //            window.location.href = '/Lease/LeaseDetails-Summary?id=' + data.sd_id;
    //        }
    //    });
    //    this.setState({ editMode: false });
    //    //Redirect to the created lease!
    //    //const data = await response.json();
    //    //if (data && data.sd_id) {
    //    //    window.location.href = '/Lease/LeaseDetails-Summary?id=' + data.sd_id;
    //    //}
    //    //const data = await response.json();
    //    //this.setState({ lease: data });
    //}
    async SaveLease() {
        /*this.setState({ loading: true, loadingDocument: false });*/
        const token = Session.getToken();
        const response = await fetch('api/Leases/EditLease', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(this.state.newLease)
        });
        const data = await response.json();
        if (data && data.sd_id) {
            window.location.href = '/Lease/LeaseDetails-Summary?id=' + data.sd_id;
        }
        //const data = await response.json();
        //this.setState({ lease: data });
    }
}
